import { useState } from "react";
import { BookDebateForm } from "./BookDebateForm";
import { BookDebateListItemView } from "./BookDebateListItemView";
import { BookDebateSubList } from "./BookDebateSubList";

export const BookDebateListItem = ({ debate, isRoot = false, rootId = null, page = null }) => {
    const [reply, setReply] = useState(false);
    const [modify, setModify] = useState(false);
    const [subList, setSubList] = useState(false);
    
    // 답글폼을 토글
    const onToggleReply = () => {
        setReply(!reply);
        setModify(reply ? modify : false);
    }

    // 수정 창을 토글
    const onToggleModify = () => {
        setModify(!modify);
        setReply(modify ? reply : false);
    }

    const onToggleSubList = () => {
        setSubList(!subList);
    }

    if (debate === null) return null;

    return (
        <div className={`reply_group ${debate.topicYn === 'Y' ? 'topic' : 'normal'} ${debate.id}`}>
            <BookDebateListItemView debate={debate} isRoot={isRoot}
                onReplyForm={onToggleReply} onModifyForm={onToggleModify} onSubDebateList={onToggleSubList}>
                {reply && <BookDebateForm className="reply_write input_wrap _edit cancel_form" mode="reply" comment={debate} rootId={isRoot ? null : rootId} page={page} onCancel={onToggleReply} useCancel={true} />}
                {modify && <BookDebateForm className="reply_write input_wrap _edit cancel_form" mode="modify" comment={debate} rootId={isRoot ? null : rootId} page={page} onCancel={onToggleModify} useCancel={true} />}
            </BookDebateListItemView>

            {isRoot && subList && <BookDebateSubList debate={debate} />}
        </div>
    );
};